export default __webpack_public_path__ + "static/background-music-4b2ac5ba64b35fc965de444a02e93b21.mp3";